import { Box } from "@mui/material";
import { useState, useEffect } from "react";
import axios from "axios";
import IndvList from "./IndvList";
import moment from "moment";
import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function ListArchive({ setOpenArchive }) {
  const url = process.env.REACT_APP_URL;
  const [fixedArchiveList, setFixedArchiveList] = useState([]);
  const [displayedArchiveList, setDisplayedArchiveList] = useState([]);

  useEffect(() => {
    fetchArchivedLists();
  }, []);

  const fetchArchivedLists = async () => {
    await axios
      .get(`${url}/assets/get-archived-lists`)
      .then((res) => {
        setFixedArchiveList(res.data.archivedLists);
        setDisplayedArchiveList(res.data.archivedLists);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Box className="list-archive-modal">
      <section className="list-archive-section">
        <Button className="close-btn-one" onClick={() => setOpenArchive(false)}>
          <CloseIcon fontSize="large" color="error" />
        </Button>
        <h2>Lists Archive</h2>
        {displayedArchiveList.length > 0 ? (
          <secton className="list-table-container">
            <table className="list-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Created</th>
                  <th>CSV</th>
                </tr>
              </thead>
              <tbody>
                {displayedArchiveList.map((l, i) => {
                  let csvData = [l];

                  let newcsvData = csvData
                    .map((list) => {
                      return list.assets.map((asset) => ({
                        listId: list.listId,
                        listName: list.name,
                        createdAt: moment(list.createdAt).format("DD/MM/YY"),
                        assetId: asset.assetId,
                        assetName: asset.assetName,
                        serialNumber: asset.serialNumber,
                      }));
                    })
                    .flat();

                  return (
                    <IndvList newcsvData={newcsvData} l={l} archive={true} />
                  );
                })}
              </tbody>
            </table>
          </secton>
        ) : (
          <h3 style={{ textAlign: "center" }}>No lists</h3>
        )}{" "}
      </section>
      <Button
        className="close-btn"
        variant="contained"
        color="error"
        onClick={() => setOpenArchive(false)}
      >
        Close
      </Button>
    </Box>
  );
}
